import classes from "./Logo.module.scss";
import classNames from "classnames";
import {FC} from "react";


interface IProps {
    is_animated?: boolean
    size?: "small" | "medium" | "large"
}

const Logo: FC<IProps> = ({is_animated = false, size = "medium"}) => {

    return (
        <div className={classNames({
            [classes.Logo]: true,
            [classes[`Logo__${size}`]]: true,
            [classes.Logo__animation]: is_animated,
        })}>
            <svg viewBox="0 0 300 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className={classNames({
                    [classes.Logo__animation__yellow]: is_animated
                })}
                      fillRule="evenodd" clipRule="evenodd"
                      d="M68.5804 23.7411C66.3879 25.8975 62.8625 25.8683 60.7061 23.6758C58.5497 21.4833 58.5789 17.9579 60.7714 15.8014C62.9639 13.6451 66.4893 13.6743 68.6457 15.8668C69.4097 16.6436 69.8994 17.5877 70.1157 18.579L80.7973 18.6677L80.7537 23.9122L78.2791 23.8916L78.3021 21.1218L75.5271 21.0988L75.5042 23.8686L73.0295 23.8481L73.0525 21.0782L70.0951 21.0537C69.8624 22.0413 69.3572 22.9771 68.5804 23.7411ZM66.8451 21.9768C65.627 23.1747 63.6684 23.1585 62.4704 21.9405C61.2724 20.7224 61.2887 18.7638 62.5067 17.5658C63.7248 16.3678 65.6834 16.3841 66.8814 17.6021C68.0794 18.8202 68.0631 20.7788 66.8451 21.9768Z"
                      fill="#DEFF00"/>
                <path className={classNames({
                    [classes.Logo__animation__yellow]: is_animated
                })}
                      d="M74.5176 0.164062C81.9021 0.164062 87.5527 1.84186 91.4688 5.19727C95.3848 8.51628 97.3427 13.4402 97.3428 19.9688C97.3428 26.5339 95.3848 31.4941 91.4688 34.8496C87.5527 38.1686 81.9959 39.8281 74.7979 39.8281H64.0566C56.9331 39.8281 51.4132 38.1686 47.4971 34.8496C43.581 31.4941 41.623 26.5338 41.623 19.9688C41.6231 13.4402 43.581 8.51628 47.4971 5.19727C51.4132 1.8418 57.0637 0.164062 64.4482 0.164062H74.5176ZM59.6426 7.16406C54.6637 7.16419 50.6279 11.2008 50.6279 16.1797V23.9717C50.628 28.9506 54.6637 32.9872 59.6426 32.9873H79.207C84.1859 32.9871 88.2217 28.9505 88.2217 23.9717V16.1797C88.2217 11.2008 84.1859 7.16426 79.207 7.16406H59.6426Z"
                      fill="#DEFF00"/>
                <path className={classNames({
                    [classes.Logo__animation__white]: is_animated
                })}
                      d="M0 40V0H8.95105V32.7273H38.2098V40H0Z" fill="white"/>
                <path className={classNames({
                    [classes.Logo__animation__white]: is_animated
                })}
                      d="M101.18 40V0.111887H110.131V16.3916H123.446L136.593 0.111887H147.726L131.278 20.028L147.726 40H136.593L123.39 23.6643H110.131V40H101.18Z"
                      fill="white"/>
                <path className={classNames({
                    [classes.Logo__animation__white]: is_animated
                })}
                      d="M152.207 40V0.111887H161.158V16.3916H174.473L187.62 0.111887H198.753L182.305 20.028L198.753 40H187.62L174.417 23.6643H161.158V40H152.207Z"
                      fill="white"/>
                <path className={classNames({
                    [classes.Logo__animation__white]: is_animated
                })}
                      d="M203.234 40V0H247.094V7.27273H212.185V16.1119H243.85V23.3846H212.185V32.7273H247.094V40H203.234Z"
                      fill="white"/>
                <path className={classNames({
                    [classes.Logo__animation__white]: is_animated
                })}
                      d="M253.223 40V0H286.734C290.874 0 294.081 1.04429 296.356 3.13287C298.669 5.22144 299.825 8.39161 299.825 12.6434C299.825 16.2611 298.986 19.0956 297.307 21.1469C295.629 23.1981 293.242 24.4848 290.146 25.007L299.377 40H289.195L280.636 25.2867H262.174V40H253.223ZM285.671 7.27273H262.174V17.958L285.671 18.014C287.312 18.014 288.561 17.6037 289.419 16.7832C290.314 15.9627 290.762 14.5828 290.762 12.6434C290.762 10.6667 290.314 9.28671 289.419 8.5035C288.561 7.68298 287.312 7.27273 285.671 7.27273Z"
                      fill="white"/>
            </svg>
        </div>
    )
}

export default Logo;